import blueprintPong from './blueprint-pong.png';
import jumpyBlock from './jumpy-block.png';
import logo from './logo.png';
import logoChristmas from './logo-christmas.png';
import logoHalloween from './logo-halloween.png';
import matrixDigitalRain from './matrix-digital-rain.png';
import recipeBox from './recipe-box.png';
import simonGame from './simon-game.png';
import strimko from './strimko.png';
import tiny from './tiny.png';
import twitchStatusViewer from './twitch-status-viewer.png';
import youtubeViewer from './youtube-viewer.png';

export default {
  'blueprint-pong': blueprintPong,
  'jumpy-block': jumpyBlock,
  logo,
  logoChristmas,
  logoHalloween,
  'matrix-digital-rain': matrixDigitalRain,
  'recipe-box': recipeBox,
  'simon-game': simonGame,
  strimko,
  tiny,
  'twitch-status-viewer': twitchStatusViewer,
  'youtube-viewer': youtubeViewer,
};



// WEBPACK FOOTER //
// ./src/images/index.js